import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

const COMPONENT_CSS_CLASSNAME = 'evacuation-top-status-bar';
const bemE = suffix => `${COMPONENT_CSS_CLASSNAME}__${suffix}`;

const EvacuationTopStatusBar = ({
	isActive,
	percents,
	employeesSave,
	employeesStart,
	type,
}) =>
	isActive ? (
		<div className={COMPONENT_CSS_CLASSNAME}>
			<span className={bemE('text-progress')}>
				<b>{`${employeesSave}/${employeesStart} `}</b> Evacuated{' '}
				{`(${percents}%)`}
			</span>
			<span className={bemE('text')}>{type} in progress</span>
		</div>
	) : null;

EvacuationTopStatusBar.defaultProps = {
	percents: 0,
	employeesSave: 0,
	employeesStart: 0,
	isActive: false,
};

EvacuationTopStatusBar.propTypes = {
	percents: PropTypes.number,
	employeesSave: PropTypes.number,
	employeesStart: PropTypes.number,
	isActive: PropTypes.bool,
};

export default EvacuationTopStatusBar;



// WEBPACK FOOTER //
// ./src/pages/evacuation-demo/components/evacuation-top-status-bar/index.js